import { notifications } from '@mantine/notifications';
import { getAirlinesKey, useCreateAirline } from 'api-hooks/airline';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import AirlineForm from './components/form';

export default function AirlineCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateAirline();
  const permission = useGetCrudPermission('airlines');

  return (
    <AirlineForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);

        queryClient.refetchQueries([getAirlinesKey()[0]]);

        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.AirlinesView, {
            id: result.data?.id,
          });
        }

        notifications.show({ message: result?.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
